import { useRouteMatch } from 'react-router-dom';

/**
 * Consider using
 *  import { useParams } from 'react-router-dom';
 */
export const createUseParams =
  <TParams extends { [K in keyof TParams]?: string }>() =>
  () =>
    useRouteMatch<TParams>().params;
